// =============================================================
// TARTALOM - MINDEN SZÖVEG ITT MÓDOSÍTHATÓ
// =============================================================

import {
  ClipboardCheck, Clock, FileText,
  MessageCircle, Heart, TrendingUp,
  Volume2, Target, CheckCircle2,
  BookOpen, Brain, Sparkles,
  Ear, Volume1, Mic,
  Smile, Wind, Activity,
  MessageSquare, Languages,
  GraduationCap, Award, Users,
  Droplets, Facebook,
} from 'lucide-react';

// ---------------------------------------------------------------
// OLDAL ALAP ADATOK
// ---------------------------------------------------------------
export const SITE = {
  name: 'Mosolytorna Logopédia',
  personName: 'Peredi Krisztina',
  personTitle: 'Gyógypedagógus | Logopédus | Szurdopedagógus | Dsmile Certifikált Tréner',
  location: 'Dunakeszi',
  facebookGroupUrl: 'https://www.facebook.com/groups/cseppbaratok.doterra',
};

// ---------------------------------------------------------------
// KAPCSOLAT ADATOK (captcha mögött)
// ---------------------------------------------------------------
export const CONTACT = {
  phone: '+36 20 460 50 75',
  phoneDisplay: '+36 20 460 50 75',
  phoneTel: '+36204605075',
  email: 'kriszta.peredi@gmail.com',
  // === IDE ÍRD A SAJÁT LINKJEIDET ===
  facebookUrl: 'https://www.facebook.com/krisztina.peredi.7/',
  whatsappUrl: 'https://wa.me/36204605075',
};

// ---------------------------------------------------------------
// NAVIGÁCIÓ
// ---------------------------------------------------------------
export const NAV_CONTENT = {
  mainLinks: [
    { href: '/', label: 'Főoldal' },
    { href: '/rolam', label: 'Rólam' },
    { href: '/illoolajok', label: 'Esszenciális olajok világa' },
    { href: '/kapcsolat', label: 'Kapcsolat' },
  ],
  serviceLinks: [
    { href: '/szolgaltatasok/vizsgalat', label: 'Logopédiai vizsgálat' },
    { href: '/szolgaltatasok/megkesett-beszed', label: 'Megkésett beszédfejlődés' },
    { href: '/szolgaltatasok/artikulacios-zavar', label: 'Artikulációs zavar (pösze)' },
    { href: '/szolgaltatasok/diszlexia-prevencio', label: 'Diszlexia-prevenció' },
    { href: '/szolgaltatasok/beszedeszleles', label: 'Beszédészlelés fejlesztése' },
    { href: '/szolgaltatasok/nyelvlokeses-nyeles', label: 'Nyelvlökéses nyelés terápiája' },
    { href: '/szolgaltatasok/nyelvi-fejlodes', label: 'Nyelvi fejlődési zavar' },
  ],
};

// ---------------------------------------------------------------
// FŐOLDAL - HERO
// ---------------------------------------------------------------
export const HERO = {
  name: 'Peredi Krisztina',
  title: 'Gyógypedagógus | Logopédus | Szurdopedagógus | Dsmile Certifikált Tréner',
  description:
    'Üdvözöllek a Mosolytorna Logopédia oldalán! 2004 óta segítem a gyermekek beszéd-, és kommunikációs készségének a fejlődését, 2015 óta pedig felnőttekkel is dolgozom. Logopédusként, szurdopedagógusként abban segítek, hogy a megszólalás könnyebb, a beszéd tisztább, a kommunikáció magabiztosabb legyen a mindennapokban is. Holisztikus szemléletben gondolkodom: nemcsak a hangokra figyelek, hanem a gyermek és a család egészére. A terápiás munkát szükség esetén aromaterápiás támogatással is kiegészítem, finoman, biztonságosan, a nyugodt fókusz és a jó közérzet érdekében. Célom, hogy mindenki a saját tempójában, egyre magabiztosabban tudjon kibontakozni.',
  ctaPrimary: { label: 'Időpont egyeztetés', href: '/kapcsolat' },
  ctaSecondary: { label: 'Szolgáltatásaim', href: '/szolgaltatasok' },
};

// ---------------------------------------------------------------
// FŐOLDAL - GYORS ÁTTEKINTŐ KÁRTYÁK
// ---------------------------------------------------------------
export const HOME_FEATURES = [
  {
    Icon: GraduationCap,
    gradient: 'from-pink-100 to-pink-200',
    iconColor: 'text-pink-600',
    title: '20+ év tapasztalat',
    desc: '2004 óta aktív logopédusként segítem a gyermekeket és felnőtteket.',
  },
  {
    Icon: Heart,
    gradient: 'from-orange-100 to-orange-200',
    iconColor: 'text-orange-600',
    title: 'Személyre szabott',
    desc: 'Minden foglalkozás az egyéni szükségletekhez igazodik.',
  },
  {
    Icon: Users,
    gradient: 'from-cyan-100 to-cyan-200',
    iconColor: 'text-cyan-600',
    title: 'Családközpontú',
    desc: 'A szülőket aktívan bevonom a fejlesztési folyamatba.',
  },
  {
    Icon: Award,
    gradient: 'from-purple-100 to-purple-200',
    iconColor: 'text-purple-600',
    title: 'Dsmile Tréner',
    desc: '2018 óta certifikált Dsmile Body Balance Tréner vagyok.',
  },
];

// ---------------------------------------------------------------
// RÓLAM OLDAL
// ---------------------------------------------------------------
export const ABOUT = {
  educationCards: [
    {
      Icon: GraduationCap,
      gradient: 'from-pink-100 to-pink-200',
      iconColor: 'text-pink-600',
      title: 'Végzettség',
      desc: 'Bárczi Gusztáv Gyógypedagógiai Tanárképző Főiskola',
    },
    {
      Icon: Award,
      gradient: 'from-cyan-100 to-cyan-200',
      iconColor: 'text-cyan-600',
      title: 'Tapasztalat',
      desc: '2004 óta logopédusként',
    },
    {
      Icon: BookOpen,
      gradient: 'from-green-100 to-green-200',
      iconColor: 'text-green-600',
      title: 'Certifikáció',
      desc: 'Dsmile Certifikált Tréner',
    },
  ],
  bioParagraphs: [
    '<strong>Végzettségem</strong><br/>A Bárczi Gusztáv Gyógypedagógiai Tanárképző Főiskolán szereztem diplomát gyógypedagógiai tanárként (logopédia 1995, szurdopedagógia–oligofrénpedagógia 1994).',
    '<strong>Szakmai fókusz és tapasztalat</strong><br/>2004 óta aktívan dolgozom logopédusként. A korai életkortól kezdve a beszéd- és nyelvi fejlődés, az artikuláció javítása, a beszédészlelés–beszédmegértés fejlesztése, valamint a nyelvlökéses nyelés diagnosztikája és terápiája is a kiemelt területeim közé tartozik.',
    '<strong>Továbbképzések, módszerek</strong><br/>A gyógypedagógiai alapokra több, a diagnosztikát és a terápiás munkát támogató képzés épül: SEED Fejlődési Skála, GMP beszédpercepciós vizsgálat és terápia, logopédiai diagnosztika, Sindelar-program, nyelvlökéses nyelés vizsgálata és terápiája akkreditált képzésen, LingualBalance OTKM Orofaciális taktilis-kinesztéziás myoterápia a szabályos nyelésfunkcióért, Bázis20 komplex logopédus továbbképzési program, a 3x5 módszer a nyelvlökéses nyelés komplex vizsgálatára és terápiájára, Kulcsár-féle Komplex mozgásterápiás képzés, DSmile Body Balance Tréning, VoiceGym hangterápia.',
    'Emellett jártasságot szereztem az SMR henger (Csiky SMR System képzése), a kinesiologiai tape (Balance Medical Fitness Akadémia), valamint az esszenciális olajok tudatos használatában is.',
    '2014-ben a Kaposvári Egyetem Közoktatási vezető és pedagógus szakvizsga szakirányú továbbképzésén szakvizsgát tettem. 2018-ban Dsmile certifikált tréneri végzettséget szereztem.',
    '<strong>Szemlélet</strong><br/>Holisztikus megközelítéssel dolgozom: a célom, hogy a változás ne csak a foglalkozáson legyen „szép", hanem a mindennapokban is működjön – nyugodtabb fókusz, könnyebb megszólalás, stabilabb kommunikáció.',
  ],
  therapyAreas: [
    'Megkésett beszédfejlődés és beszédindítás',
    'Beszédhibák terápiája (enyhe és súlyos esetekben)',
    'Beszédészlelési és beszédmegértési zavarok kezelése',
    'Tanulási zavarok megelőzése és korrekciója',
    'Figyelmi és grafomotoros nehézségek fejlesztése',
    'Nyelvlökéses nyelés terápiája',
  ],
};

// ---------------------------------------------------------------
// SZOLGÁLTATÁSOK OLDAL
// ---------------------------------------------------------------
export const SERVICES_PAGE = {
  // --- A) Felső bevezető szöveg: kettévágva ---
  mosolytornaDescription:
    'Komplex logopédiai és fejlesztő foglalkozásokat biztosítok gyermekek és felnőttek számára, kiemelten a beszéd-, nyelvi és tanulási nehézségek, a nyelésproblémák kezelése területén.',
  mosolytornaDescription2:
    'A fejlesztések mindig az egyéni szükségletekhez igazodnak, és a hagyományos logopédiai módszereket holisztikus szemlélettel ötvözöm.',

  // --- B) "Munkám során…" lista: cím + kiegészítés struktúra ---
  mosolytornaFocusItems: [
    { title: 'Megkésett beszédfejlődés', detail: 'beszédindítás, kommunikáció fejlesztése' },
    { title: 'Artikulációs zavarok', detail: 'hangcsere, hangkihagyás, torzítás terápiája' },
    { title: 'Beszédészlelés és beszédmegértés', detail: 'célzott észlelési és megértési fejlesztés' },
    { title: 'Tanulási zavarok prevenciója', detail: 'megelőzés és korrekció, részképességek fejlesztése' },
    { title: 'Figyelmi és grafomotoros nehézségek', detail: 'komplex támogatás kisgyermekeknek' },
  ],

  // --- C) Három infókártya: rövidített szöveggel ---
  mosolytornaInfo: [
    { title: 'Formája', desc: 'Egyéni vagy páros óra · 50 perc', border: 'border-pink-400' },
    { title: 'Életkor', desc: 'Óvodástól felnőttig', border: 'border-cyan-400' },
    { title: 'Célja', desc: 'Kommunikáció javítása · optimális működés', border: 'border-purple-400' },
  ],

  // --- D) "Kinek ajánlott?" – 3 alcsoportra bontva ---
  mosolytornaIndicationGroups: [
    {
      groupTitle: 'Beszéd és hangképzés',
      items: [
        'Hibás artikuláció',
        'Beszéd- és hangképzési zavarok',
        'Koncentrációs nehézségek',
        'Nyelvlökéses nyelés gyanúja',
      ],
    },
    {
      groupTitle: 'Nyelés, légzés, száj körüli működés',
      items: [
        'Szájlégzés, gyakran kiszáradó torok, repedezett ajkak',
        'Állkapocs ízületi (TMI) panaszok, szájnyitási korlátozottság',
        'Nyelési nehézségek, reflux',
        'Fogcsikorgatás, fogérzékenység',
        'Horkolás, alvási apnoe',
      ],
    },
    {
      groupTitle: 'Testtartás, figyelem, kiegészítő tünetek',
      items: [
        'Arcasszimetria',
        'Fogazati eltérés',
        'Testtartási és/vagy egyensúlyi problémák',
        'Gyakori fejfájás, nyaki fájdalmak, migréné',
        'Karikás szemek, asszimetrikusan álló szemek és fülek',
        'Gyakori megfázás, orrdugulás',
      ],
    },
  ],

  // --- Régi flat lista megtartva kompatibilitás miatt (ha kell) ---
  mosolytornaIndications: [
    'Nyelvlökéses nyelés gyanúja',
    'Szájlégzés, gyakran kiszáradó torok, repedezett ajkak',
    'Arcasszimetria',
    'Hibás artikuláció',
    'Állkapocs ízületi (TMI) panaszok, szájnyitási korlátozottság',
    'Fogazati eltérés',
    'Testtartási és/vagy egyensúlyi problémák',
    'Gyakori fejfájás, nyaki fájdalmak, migréné',
    'Koncentrációs nehézségek',
    'Beszéd- és hangképzési zavarok',
    'Karikás szemek, asszimetrikusan álló szemek és fülek',
    'Gyakori megfázás, orrdugulás',
    'Nyelési nehézségek, reflux',
    'Fogcsikorgatás, fogérzékenység',
    'Horkolás, alvási apnoe',
  ],

  whyChooseMe: [
    '2004 óta aktív logopédus',
    'Egyéni, a gyermek igényeire szabott fejlesztési terv',
    'Családközpontú megközelítés',
    'Hagyományos és innovatív módszerek ötvözése',
    'Szeretetteljes, biztonságos környezet',
  ],
  serviceCards: [
    { href: '/szolgaltatasok/vizsgalat', title: 'Logopédiai vizsgálat', desc: 'Komplex logopédiai állapotfelmérés, amely feltárja a beszéd-, nyelvi és kommunikációs készségek aktuális szintjét. Az eredmények alapján személyre szabott terápiás terv készül.', gradient: 'from-pink-100 to-purple-100', border: 'border-pink-300' },
    { href: '/szolgaltatasok/megkesett-beszed', title: 'Megkésett beszédfejlődés', desc: 'Célzott, egyéni logopédiai fejlesztés azoknak a gyermekeknek, akiknél a beszédindulás késik, a szókincs lassabban bővül, vagy a mondatalkotás nem indul meg az életkornak megfelelően.', gradient: 'from-yellow-100 to-orange-100', border: 'border-orange-300' },
    { href: '/szolgaltatasok/artikulacios-zavar', title: 'Artikulációs zavar (pösze)', desc: 'Az artikulációs zavarok a beszédhangok hibás ejtését jelentik: a hang torzul, felcserélődik vagy kiesik. A terápia játékos gyakorlatsorokkal segíti a helyes hangképzést.', gradient: 'from-cyan-100 to-blue-100', border: 'border-cyan-300' },
    { href: '/szolgaltatasok/diszlexia-prevencio', title: 'Diszlexia-prevenció', desc: 'A diszlexia-prevenció célja az olvasás- és írástanuláshoz szükséges alapkészségek tudatos megerősítése. Nem betűtanítás történik, hanem azoknak a nyelvi és észlelési területeknek a fejlesztése, amelyekre később az olvasás épül.', gradient: 'from-purple-100 to-pink-100', border: 'border-purple-300' },
    { href: '/szolgaltatasok/beszedeszleles', title: 'Beszédészlelés fejlesztése', desc: 'Azoknak a gyermekeknek szól, akiknél a hallott beszéd feldolgozása bizonytalan: gyakran visszakérdeznek, összekevernek hasonló szavakat, nehezebben követik az utasításokat.', gradient: 'from-green-100 to-cyan-100', border: 'border-green-300' },
    { href: '/szolgaltatasok/nyelvlokeses-nyeles', title: 'Nyelvlökéses nyelés vizsgálata és terápiája', desc: 'A nyelvlökéses nyelésnél a nyelv nem megfelelően helyezkedik nyelés közben és nyugalomban. Ez hatással lehet a harapásra, fogszabályozás eredményére és a beszédtisztaságra.', gradient: 'from-blue-100 to-purple-100', border: 'border-blue-300' },
    { href: '/szolgaltatasok/nyelvi-fejlodes', title: 'Nyelvi fejlődési zavar', desc: 'A nyelvi fejlődési zavar esetén a gyermek nyelvi fejlődése lassabban vagy eltérően alakul. A fejlesztés célja az életkornak megfelelő nyelvi működés támogatása és a kommunikáció gördülékenyebbé tétele.', gradient: 'from-orange-100 to-yellow-100', border: 'border-yellow-300' },
  ],
};

// ---------------------------------------------------------------
// ILLÓOLAJOK OLDAL
// ---------------------------------------------------------------
export const OILS_PAGE = {
  intro: 'A természet erejét hasznosítom munkám során és a mindennapi életben.',
  usageItems: [
    {
      Icon: Droplets,
      gradient: 'from-purple-400 to-pink-500',
      title: 'Párologtatás',
      desc: 'A terápiás foglalkozások alatt nyugtató, koncentrációt segítő olajokat párologtatok a harmonikus légkör megteremtéséhez.',
    },
    {
      Icon: Heart,
      gradient: 'from-cyan-400 to-blue-500',
      title: 'Szülők támogatása',
      desc: 'Szívesen ajánlok nyugtató vagy jókedvet hozó olajokat a családoknak, amelyek otthon is támogathatják a család közérzetét, alvását, egészségét.',
    },
    {
      Icon: Sparkles,
      gradient: 'from-green-400 to-yellow-500',
      title: 'Gyermekek kedvence',
      desc: 'A gyerekek szeretik az illatok változatosságát, és gyakran kifejezetten kérik a kedvenc illatukat a foglalkozások alatt.',
    },
  ],
  community: {
    title: 'Cseppbarátok Közösség',
    subtitle: '"Ahol az illatok történeteket mesélnek"',
    desc: 'Csatlakozz a <strong>több ezer fős Facebook csoportomhoz</strong>, ahol megosztom az illóolajokkal kapcsolatos tapasztalataimat, tippeket adok a használatukhoz, és közösséget építünk azok számára, akik hisznek a természet erejében és a természetes megoldásokban.',
    ctaLabel: 'Csatlakozz a csoporthoz',
    note: 'A csoportban rendelhetsz is illóolajokat',
  },
};

// ---------------------------------------------------------------
// KAPCSOLAT OLDAL
// ---------------------------------------------------------------
export const CONTACT_PAGE = {
  title: 'Kapcsolat',
  subtitle: 'Vedd fel velem a kapcsolatot bizalommal, szívesen válaszolok minden kérdésedre!',
  captchaTitle: 'Kapcsolatfelvétel',
};

// ---------------------------------------------------------------
// SZOLGÁLTATÁS RÉSZLETES OLDALAK KONFIGURÁCIÓI
// ---------------------------------------------------------------

export const SERVICE_VIZSGALAT = {
  title: 'Logopédiai vizsgálat',
  subtitle: 'Komplex állapotfelmérés gyermekeknek és felnőtteknek',
  Icon: ClipboardCheck,
  iconGradient: 'from-pink-500 to-purple-500',
  bgFrom: 'from-pink-50',
  bgTo: 'to-purple-50',
  description:
    'Komplex logopédiai állapotfelmérés, amely feltárja a beszéd-, nyelvi és kommunikációs készségek aktuális szintjét. Az eredmények alapján személyre szabott terápiás terv készül.',
  infoCards: [
    { Icon: Clock, iconColor: 'text-orange-600', gradient: 'from-pink-100 to-orange-100', title: 'Időtartam', value: '60–90 perc' },
    { Icon: ClipboardCheck, iconColor: 'text-cyan-600', gradient: 'from-cyan-100 to-blue-100', title: 'Formája', value: 'Egyéni vizsgálat' },
    { Icon: FileText, iconColor: 'text-purple-600', gradient: 'from-purple-100 to-pink-100', title: 'Eredmény', value: 'Írásos szakvélemény + terv' },
  ],
  warningTitle: 'Mikor javasolt a vizsgálat?',
  // --- 2 alcsoportra bontva ---
  warningGroups: [
    {
      groupTitle: 'Gyermek jelei',
      items: [
        'Beszéde életkorához képest késik vagy lassabban indul',
        'Hangokat cserél, kihagy vagy torzít',
        'Beszéde nehezen érthető a környezet számára',
      ],
    },
    {
      groupTitle: 'Iskolai jelzések / fogszabályozás',
      items: [
        'Óvodában/iskolában jeleztek beszéd- vagy nyelvi nehézséget',
        'Fogszabályozás előtt vagy azzal párhuzamosan (pl. nyelvlökéses nyelés gyanúja)',
      ],
    },
  ],
  // --- Régi flat lista megtartva kompatibilitás miatt ---
  warningItems: [
    'Ha a gyermek beszéde életkorához képest késik vagy lassabban indul be',
    'Ha hangokat cserél, kihagy, torzít, vagy bizonyos hangok tartósan nem alakulnak ki',
    'Ha a beszéde nehezen érthető a környezet számára',
    'Ha óvodában/iskolában jeleztek beszéd- vagy nyelvi nehézséget',
    'Fogszabályozás előtt, illetve fogszabályozással párhuzamosan (pl. nyelvlökéses nyelés gyanúja esetén)',
  ],
  detailsTitle: 'A vizsgálat elemei',
  // --- Rövidített cím + rövid magyarázat ---
  details: [
    { title: 'Beszédhangok és artikuláció', desc: 'Hangok tisztasága, hangképzési jellemzők', gradient: 'from-pink-50 to-purple-50', border: 'border-pink-500' },
    { title: 'Beszédészlelés és megértés', desc: 'Hallott beszéd feldolgozása, differenciálása', gradient: 'from-purple-50 to-blue-50', border: 'border-purple-500' },
    { title: 'Nyelvhasználat', desc: 'Szókincs, mondatalkotás, nyelvtani szerkezetek', gradient: 'from-blue-50 to-cyan-50', border: 'border-blue-500' },
    { title: 'Kommunikáció', desc: 'Beszédkedv, párbeszéd, interakció', gradient: 'from-cyan-50 to-green-50', border: 'border-cyan-500' },
    { title: 'Orofaciális működés', desc: 'Szájmozgások, nyelésmintázat, izomtónus', gradient: 'from-green-50 to-yellow-50', border: 'border-green-500' },
    { title: 'Részképességek', desc: 'Figyelem, emlékezet, percepció (szükség szerint)', gradient: 'from-yellow-50 to-orange-50', border: 'border-yellow-500' },
  ],
  // --- "Fontos tudni" doboz: 2 mondatra vágva ---
  importantNote:
    'Szóban azonnal visszajelzést adok a vizsgálat eredményeiről. Írásos dokumentációt (részletes eredmények, fejlesztési javaslatok, terápiás terv, otthoni gyakorlási ajánlások) 1–2 héten belül kap.',
  resultsTitle: 'Mit kap a vizsgálat után?',
  // --- Átrendezve: kézzelfoghatók elöl, konzultáció a végén ---
  results: [
    'Írásos szakvélemény a vizsgálati eredményekről',
    'Személyre szabott terápiás terv konkrét célokkal',
    'Otthoni gyakorlásra vonatkozó ajánlások',
    'Javaslat a terápia időtartamára és gyakoriságára',
    'Szóbeli konzultáció és válaszok minden kérdésre',
  ],
  resultsBgGradient: 'from-purple-100 via-pink-100 to-orange-100',
  resultsBulletColor: 'bg-purple-500',
  // --- CTA gomb szöveg ---
  ctaLabel: 'Időpont egyeztetés',
};

export const SERVICE_MEGKESETT = {
  title: 'Megkésett beszédfejlődés terápiája',
  subtitle: 'Beszédindítás, nyelvi fejlesztés, a kommunikáció fejlesztése',
  Icon: MessageCircle,
  iconGradient: 'from-yellow-500 to-orange-500',
  bgFrom: 'from-yellow-50',
  bgTo: 'to-orange-50',
  description:
    'Célzott, egyéni logopédiai fejlesztés azoknak a gyermekeknek, akiknél a beszédindulás késik, a szókincs lassabban bővül, vagy a mondatalkotás nem indul meg az életkornak megfelelően.',
  infoCards: [
    { Icon: Heart, iconColor: 'text-orange-600', gradient: 'from-yellow-100 to-orange-100', title: 'Időtartam', value: '45–50 perc' },
    { Icon: TrendingUp, iconColor: 'text-pink-600', gradient: 'from-orange-100 to-pink-100', title: 'Gyakoriság', value: 'Heti 1–2 alkalom' },
    { Icon: MessageCircle, iconColor: 'text-purple-600', gradient: 'from-pink-100 to-purple-100', title: 'Megközelítés', value: 'Játékos, kapcsolatközpontú fejlesztés' },
  ],
  warningTitle: 'Kinek ajánlott?',
  warningItems: [
    '2–4 éves gyermekeknek, akik kevés aktív szóval kommunikálnak',
    'Akik főként gesztusokkal, mutatással kommunikálnak',
    'Akiknek beszédmegértése jó, de nem vagy alig beszélnek',
    '2,5–3 éves kor körül nem jelennek meg a kétszavas közlések',
    'Családoknak, akik konkrét segítséget keresnek',
  ],
  detailsTitle: 'A terápia fókuszpontjai',
  details: [
    { title: 'Kommunikációs motiváció', desc: 'Kapcsolódás, közös figyelem, kezdeményezés', gradient: 'from-yellow-50 to-orange-50', border: 'border-yellow-500' },
    { title: 'Szókincsbővítés', desc: 'Új szavak tanítása, beépítés a mindennapokba', gradient: 'from-orange-50 to-pink-50', border: 'border-orange-500' },
    { title: 'Mondatalkotás beindítása', desc: 'Kétszavas közlések → többszavas mondatok', gradient: 'from-pink-50 to-purple-50', border: 'border-pink-500' },
    { title: 'Beszédészlelés és beszédértés', desc: 'Utasítások megértése, auditív figyelem', gradient: 'from-purple-50 to-blue-50', border: 'border-purple-500' },
    { title: 'Hangképzés előkészítése', desc: 'Száj- és nyelvmozgások, hangutánzás, hangindítás', gradient: 'from-blue-50 to-cyan-50', border: 'border-blue-500' },
    { title: 'Szülői konzultáció', desc: 'Működő gyakorlatok és helyzetek a hétköznapokra', gradient: 'from-cyan-50 to-green-50', border: 'border-cyan-500' },
  ],
  importantNote:
    'Ha 2,5–3 éves kor körül a gyermek kevés szót használ, érdemes logopédiai vizsgálatot kérni. A korai támogatás gyorsítja a fejlődést és csökkenti a későbbi nehézségek kockázatát.',
  resultsTitle: 'Várható eredmények',
  results: [
    'Dinamikusan bővülő szókincs',
    'Kétszavas közlések, majd mondatok fejlődése',
    'Erősödő kommunikációs kedv és beszédöröm',
    'Érthetőbb beszéd, tisztább hangindítás',
    'Könnyebb mindennapi kommunikáció',
  ],
  resultsBgGradient: 'from-cyan-100 via-blue-100 to-purple-100',
  resultsBulletColor: 'bg-cyan-500',
  ctaLabel: 'Időpont egyeztetés',
};

export const SERVICE_ARTIKULACIOS = {
  title: 'Artikulációs zavar (pöszeség) terápiája',
  subtitle: 'Hangképzési hibák javítása, tiszta beszéd',
  Icon: Volume2,
  iconGradient: 'from-cyan-500 to-blue-500',
  bgFrom: 'from-cyan-50',
  bgTo: 'to-blue-50',
  description:
    'Az artikulációs zavarok a beszédhangok hibás ejtését jelentik: a hang torzul, felcserélődik vagy kiesik. A terápia játékos gyakorlatsorokkal segíti a helyes hangképzést és annak automatizálását a spontán beszédben.',
  infoCards: [
    { Icon: Target, iconColor: 'text-cyan-600', gradient: 'from-cyan-100 to-blue-100', title: 'Időtartam', value: '45–50 perc' },
    { Icon: Volume2, iconColor: 'text-blue-600', gradient: 'from-blue-100 to-purple-100', title: 'Gyakoriság', value: 'Heti 1–2 alkalom' },
    { Icon: CheckCircle2, iconColor: 'text-purple-600', gradient: 'from-purple-100 to-pink-100', title: 'Célcsoport', value: '4 éves kortól felnőttkorig' },
  ],
  warningTitle: 'Gyakori artikulációs hibák',
  warningItems: [
    'Pöszeség (szigmatizmus): s, zs, cs, sz, z, c, dz, dzs hangok torz ejtése',
    'Rotacizmus: r hang ejtési zavara',
    'Lambdacizmus: l hang problémája',
    'Hangcserék: pl. k↔t, g↔d, sz↔s',
    'Hangkihagyások: egyes hangok hiánya a beszédből',
  ],
  detailsTitle: 'A terápia menete',
  details: [
    { title: '1. Állapotfelmérés', desc: 'Hibás hangok azonosítása, kiváltó tényezők feltérképezése', gradient: 'from-cyan-50 to-blue-50', border: 'border-cyan-500' },
    { title: '2. Hangképzés tanítása', desc: 'Helyes motorprogram kialakítása', gradient: 'from-blue-50 to-purple-50', border: 'border-blue-500' },
    { title: '3. Rögzítés és automatizálás', desc: 'Szótagok → szavak → mondatok → szöveg', gradient: 'from-purple-50 to-pink-50', border: 'border-purple-500' },
    { title: '4. Spontán beszédbe ültetés', desc: 'A hang stabil megjelenése a hétköznapi beszédben', gradient: 'from-pink-50 to-orange-50', border: 'border-pink-500' },
    { title: '5. Megerősítés', desc: 'Otthoni gyakorlás és visszamérés', gradient: 'from-orange-50 to-yellow-50', border: 'border-orange-500' },
  ],
  importantNote:
    'A fejlődés kulcsa a rendszeresség és a napi 5–10 perc otthoni gyakorlás. A szülők aktív közreműködése felgyorsítja a fejlődést.',
  importantNote2:
    'Ha 5–6 éves kor körül tartós a hanghiba vagy a beszéd érthetősége romlik, érdemes vizsgálatot kérni.',
  resultsTitle: 'Mire számíthat?',
  results: [
    'Egyéni, játékos foglalkozások heti rendszerességgel',
    'Néhány hónap alatt látványos változás indulhat',
    'Otthoni feladatok: napi 5–10 perc, pontos útmutatóval',
    'Folyamatos visszajelzés a fejlődésről',
    'Tisztább, érthetőbb beszéd és megnövekedett önbizalom',
  ],
  resultsBgGradient: 'from-green-100 via-cyan-100 to-blue-100',
  resultsBulletColor: 'bg-green-500',
  ctaLabel: 'Időpont egyeztetés',
};

export const SERVICE_DISZLEXIA = {
  title: 'Diszlexia-prevenció',
  subtitle: 'Olvasás-írás megalapozása játékos formában',
  Icon: BookOpen,
  iconGradient: 'from-purple-500 to-pink-500',
  bgFrom: 'from-purple-50',
  bgTo: 'to-pink-50',
  description:
    'A diszlexia-prevenció célja az olvasás- és írástanuláshoz szükséges alapkészségek tudatos megerősítése. Nem betűtanítás történik, hanem azoknak a nyelvi és észlelési területeknek a fejlesztése, amelyekre később az olvasás, helyesírás és szövegértés épül.',
  infoCards: [
    { Icon: Sparkles, iconColor: 'text-purple-600', gradient: 'from-purple-100 to-pink-100', title: 'Időtartam', value: '45–50 perc' },
    { Icon: Brain, iconColor: 'text-pink-600', gradient: 'from-pink-100 to-orange-100', title: 'Gyakoriság', value: 'Heti 1–2 alkalom' },
    { Icon: BookOpen, iconColor: 'text-orange-600', gradient: 'from-orange-100 to-yellow-100', title: 'Életkor', value: 'Kiemelten: 5–7 év · Rizikó esetén: 4–5 év · Hasznos: 7–8 évig' },
  ],
  warningTitle: 'Mikor javasolt a fejlesztés?',
  warningItems: [
    'Nehezen tanul meg verseket, mondókákat',
    'Hasonló hangzású hangok/szavak megkülönböztetése gondot okoz',
    'Tartós hangcsere vagy hangkihagyás a beszédben',
    'Nehézségek a ceruzafogással, rajzolással',
    'Sorrend felcserélése, ritmus nehézségek',
    'Családi előzmény (diszlexia/diszgráfia/tanulási zavar)',
  ],
  detailsTitle: 'Fejlesztési területek',
  details: [
    { title: 'Hangdifferenciálás', desc: 'Hasonló hangok megkülönböztetése', gradient: 'from-purple-50 to-pink-50', border: 'border-purple-500' },
    { title: 'Fonématudatosság', desc: 'Hangok azonosítása, szótagolás, hangokra bontás', gradient: 'from-pink-50 to-orange-50', border: 'border-pink-500' },
    { title: 'Auditív figyelem és emlékezet', desc: 'Hallott információ megtartása, utasításkövetés', gradient: 'from-orange-50 to-yellow-50', border: 'border-orange-500' },
    { title: 'Vizuális észlelés', desc: 'Betűformák, alakzatok, részletek felismerése', gradient: 'from-yellow-50 to-green-50', border: 'border-yellow-500' },
    { title: 'Téri tájékozódás', desc: 'Bal–jobb, fent–lent, sorirány', gradient: 'from-green-50 to-cyan-50', border: 'border-green-500' },
    { title: 'Finommotorika', desc: 'Szem–kéz koordináció, ceruzafogás, írás előkészítés', gradient: 'from-cyan-50 to-blue-50', border: 'border-cyan-500' },
    { title: 'Sorrendiség és ritmus', desc: 'Időbeli–téri sorrend, ritmusérzék', gradient: 'from-blue-50 to-purple-50', border: 'border-blue-500' },
  ],
  importantNote:
    'A prevenció célja nem a diagnózis, hanem az alapkészségek fejlesztése. Korai felismerés és fejlesztés esetén jobb eredmények érhetők el.',
  importantNote2:
    'Ha a fejlesztés során indokolt, javaslatot teszek a következő lépésekre.',
  resultsTitle: 'A prevenció előnyei',
  results: [
    'Könnyebb iskolakezdés, magabiztosabb olvasás-írás',
    'Tanulási nehézségek kockázatának csökkentése',
    'Erősödő figyelem, emlékezet, hangfeldolgozás',
    'Növekvő önbizalom és tanulási kedv',
    'Játékos, gyerekközpontú foglalkozások',
  ],
  resultsBgGradient: 'from-green-100 via-cyan-100 to-blue-100',
  resultsBulletColor: 'bg-green-500',
  ctaLabel: 'Időpont egyeztetés',
};

export const SERVICE_BESZEDESZLELES = {
  title: 'Beszédészlelés és beszédmegértés fejlesztése',
  subtitle: 'Jobb figyelem, könnyebb tanulás',
  Icon: Ear,
  iconGradient: 'from-green-500 to-cyan-500',
  bgFrom: 'from-green-50',
  bgTo: 'to-cyan-50',
  description:
    'Azoknak a gyermekeknek szól, akiknél a hallott beszéd feldolgozása bizonytalan: gyakran visszakérdeznek, összekevernek hasonló szavakat, nehezebben követik az utasításokat. Célzott gyakorlatokkal támogatjuk a hallási figyelmet és a nyelvi feldolgozást.',
  infoCards: [
    { Icon: Ear, iconColor: 'text-green-600', gradient: 'from-green-100 to-cyan-100', title: 'Időtartam', value: '45–50 perc' },
    { Icon: Volume1, iconColor: 'text-cyan-600', gradient: 'from-cyan-100 to-blue-100', title: 'Gyakoriság', value: 'Heti 1–2 alkalom' },
    { Icon: Mic, iconColor: 'text-blue-600', gradient: 'from-blue-100 to-purple-100', title: 'Fókusz', value: 'Hallási figyelem, beszédhang-feldolgozás' },
  ],
  warningTitle: 'Mikor lehet rá szükség?',
  warningItems: [
    'Gyakran visszakérdez, nem érti meg elsőre',
    'Nehezen követi a tanári magyarázatot',
    'Hasonló hangzású szavakat összekever (pl. hal–fal)',
    'Nehezen tanul verseket, dalokat',
    'Jellegzetes olvasás-írás hibák (betűtévesztés, lassú haladás)',
  ],
  detailsTitle: 'A fejlesztés fő elemei',
  details: [
    { title: 'Hangdifferenciálás', desc: 'Hasonló hangok elkülönítése', gradient: 'from-green-50 to-cyan-50', border: 'border-green-500' },
    { title: 'Hallási figyelem', desc: 'Fókusz, lényegkiemelés hallott anyagon', gradient: 'from-cyan-50 to-blue-50', border: 'border-cyan-500' },
    { title: 'Verbális munkamemória', desc: 'Szavak, mondatok megtartása és felidézése', gradient: 'from-blue-50 to-purple-50', border: 'border-blue-500' },
    { title: 'Beszédmegértés', desc: 'Utasítások, kérdések, történetek értése', gradient: 'from-purple-50 to-pink-50', border: 'border-purple-500' },
    { title: 'Fonológiai tudatosság', desc: 'Hangokra bontás–összefűzés (olvasás alapja)', gradient: 'from-pink-50 to-orange-50', border: 'border-pink-500' },
    { title: 'Szövegértés', desc: 'Fő információk kiemelése, sorrendiség', gradient: 'from-orange-50 to-yellow-50', border: 'border-orange-500' },
  ],
  importantNote:
    'A beszédészlelési nehézségek gyakran járnak együtt tanulási nehézségekkel – érdemes időben támogatni az alapokat. Hallásprobléma gyanúja esetén javasolt a hallás ellenőrzése is.',
  resultsTitle: 'Várható eredmények',
  results: [
    'Jobb figyelem és koncentráció a tanulásban',
    'Pontosabb beszédhang-feldolgozás és megértés',
    'Könnyebb utasításkövetés, magabiztosabb iskolai részvétel',
    'Olvasás, szövegértés és helyesírás támogatása',
    'Növekvő önbizalom a kommunikációban',
  ],
  resultsBgGradient: 'from-yellow-100 via-orange-100 to-pink-100',
  resultsBulletColor: 'bg-orange-500',
  ctaLabel: 'Időpont egyeztetés',
};

export const SERVICE_NYELVLOKES = {
  title: 'Nyelvlökéses nyelés terápiája',
  subtitle: 'Orofaciális miofunkcionális terápia (OMT)',
  Icon: Smile,
  iconGradient: 'from-blue-500 to-purple-500',
  bgFrom: 'from-blue-50',
  bgTo: 'to-purple-50',
  description:
    'A nyelvlökéses nyelésnél a nyelv nem megfelelően helyezkedik nyelés közben és nyugalomban. Ez hatással lehet a harapásra, fogszabályozás eredményére és a beszédtisztaságra. A terápia célzott gyakorlatokkal segíti a helyes nyelvpozíció és nyelési minta kialakítását.',
  infoCards: [
    { Icon: Activity, iconColor: 'text-blue-600', gradient: 'from-blue-100 to-purple-100', title: 'Időtartam', value: '45–50 perc' },
    { Icon: Wind, iconColor: 'text-purple-600', gradient: 'from-purple-100 to-pink-100', title: 'Gyakoriság', value: 'Heti 1 alkalom' },
    { Icon: Smile, iconColor: 'text-pink-600', gradient: 'from-pink-100 to-orange-100', title: 'Életkor', value: '5 éves kortól felnőttkorig' },
  ],
  warningTitle: 'Figyelmeztető jelek',
  warningItems: [
    'A nyelv nyelés közben előre tolódik / kilátszik a fogak között',
    'Nyitott száj pihenő helyzetben, ajakzárási nehézség',
    'Szájlégzés, horkolás, „bedugult orr" érzés',
    'Artikulációs hibák (t, d, n, l, sz, z, c, s, zs, cs, ty, gy, ny)',
    'Fogszabályozó javaslata logopédiai vizsgálatra',
    'Harapási eltérések (nyitott harapás, fogtorlódás)',
  ],
  detailsTitle: 'A terápia menete',
  details: [
    { title: '1. Állapotfelmérés', desc: 'Nyelési minta, nyelvpozíció, ajakzárás, izomműködés', gradient: 'from-blue-50 to-purple-50', border: 'border-blue-500' },
    { title: '2. Izomegyensúly kialakítása', desc: 'Ajak-, arc- és nyelvizmok célzott aktiválása', gradient: 'from-purple-50 to-pink-50', border: 'border-purple-500' },
    { title: '3. Helyes nyelvpozíció tanítása', desc: 'Tudatosítás nyugalomban és nyeléskor', gradient: 'from-pink-50 to-orange-50', border: 'border-pink-500' },
    { title: '4. Automatizálás', desc: 'Beépítés ivásnál, étkezésnél, beszéd közben', gradient: 'from-orange-50 to-yellow-50', border: 'border-orange-500' },
    { title: '5. Szokássá alakítás', desc: 'Napi gyakorlás, visszamérés, ellenőrzés', gradient: 'from-yellow-50 to-green-50', border: 'border-yellow-500' },
  ],
  importantNote:
    'A nyelvlökéses nyelés korrekciója időigényes, szokásmintát és izomegyensúlyt alakítunk át. A siker kulcsa a napi otthoni gyakorlás.',
  importantNote2:
    'Tartós szájlégzés, orrdugulás esetén érdemes fül-orr-gégészeti irányban is vizsgálódni.',
  importantNote3:
    'Fogszabályozás esetén a legjobb eredmény a fogszabályozó és az OMT terápia összehangolásával születik.',
  resultsTitle: 'A terápia előnyei',
  results: [
    'Stabil, helyes nyelési minta kialakítása',
    'Fogszabályozás eredményének támogatása',
    'Artikulációs zavarok javítása',
    'Orrlégzés erősítése, szájlégzés csökkentése',
    'Harmonikusabb orofaciális izomműködés',
  ],
  resultsBgGradient: 'from-green-100 via-cyan-100 to-blue-100',
  resultsBulletColor: 'bg-green-500',
  ctaLabel: 'Időpont egyeztetés',
};

export const SERVICE_NYELVI = {
  title: 'Nyelvi fejlődési zavar',
  subtitle: 'Komplex nyelvi fejlesztés gyermekeknek',
  Icon: Languages,
  iconGradient: 'from-orange-500 to-yellow-500',
  bgFrom: 'from-orange-50',
  bgTo: 'to-yellow-50',
  description:
    'A nyelvi fejlődési zavar esetén a gyermek nyelvi fejlődése lassabban vagy eltérően alakul. A fejlesztés célja az életkornak megfelelő nyelvi működés támogatása és a kommunikáció gördülékenyebbé tétele.',
  infoCards: [
    { Icon: Languages, iconColor: 'text-orange-600', gradient: 'from-orange-100 to-yellow-100', title: 'Időtartam', value: '45–50 perc' },
    { Icon: MessageSquare, iconColor: 'text-yellow-600', gradient: 'from-yellow-100 to-green-100', title: 'Gyakoriság', value: 'Heti 1–2 alkalom' },
    { Icon: TrendingUp, iconColor: 'text-green-600', gradient: 'from-green-100 to-cyan-100', title: 'Célcsoport', value: '3–12 éves gyermekek' },
  ],
  warningTitle: 'Figyelmeztető jelek',
  warningItems: [
    'Korlátozott, lassan bővülő szókincs',
    'Rövidebb, egyszerűbb mondatok az életkorhoz képest',
    'Gyakori nyelvtani pontatlanságok (ragok, toldalékok)',
    'Nehézség történetmesélésben, lényegkiemelésben',
    'Beszédmegértési bizonytalanság',
    'Nehéz kapcsolódni, párbeszédet fenntartani',
  ],
  detailsTitle: 'A fejlesztés fókuszterületei',
  details: [
    { title: 'Szókincs bővítése', desc: 'Kategóriák, fogalmi háló építése', gradient: 'from-orange-50 to-yellow-50', border: 'border-orange-500' },
    { title: 'Mondatalkotás és nyelvtan', desc: 'Ragozás, toldalékolás, szerkezetek felépítése', gradient: 'from-yellow-50 to-green-50', border: 'border-yellow-500' },
    { title: 'Beszédmegértés', desc: 'Utasítások, kérdések, történetek megértése', gradient: 'from-green-50 to-cyan-50', border: 'border-green-500' },
    { title: 'Kommunikációs készségek', desc: 'Párbeszéd, kérdezés, történetmesélés', gradient: 'from-cyan-50 to-blue-50', border: 'border-cyan-500' },
    { title: 'Kognitív-nyelvi készségek', desc: 'Kategorizálás, ok-okozat, problémamegoldás', gradient: 'from-blue-50 to-purple-50', border: 'border-blue-500' },
    { title: 'Iskolaérettség', desc: 'Szövegértés, tanórai nyelvi alapok', gradient: 'from-purple-50 to-pink-50', border: 'border-purple-500' },
  ],
  importantNote:
    'A nyelvi fejlődési zavar nem azonos az artikulációs zavarral. Itt az a kérdés, hogyan érti, építi fel és használja a nyelvet a gyermek.',
  importantNote2:
    'A korai felismerés és célzott fejlesztés különösen fontos, mert a nyelvi készségek a tanulás alapját adják.',
  importantNote3:
    'A fejlődés üteme egyéni; a cél a folyamatos, mérhető előrelépés.',
  resultsTitle: 'A terápia módszerei',
  results: [
    'Játékos nyelvi fejlesztés: mese, szerepjáték, társasjáték',
    'Természetes kommunikációs helyzetek teremtése',
    'Strukturált szókincsbővítő és nyelvtani gyakorlatok',
    'Szülői tanácsadás: otthoni stratégiák, könyvajánlók',
    'Óvoda/iskola bevonása szükség szerint',
  ],
  resultsBgGradient: 'from-cyan-100 via-blue-100 to-purple-100',
  resultsBulletColor: 'bg-cyan-500',
  ctaLabel: 'Időpont egyeztetés',
};
